var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-wrapper"},[_c('div',{staticClass:"page-title"},[_vm._t("title")],2),(_vm.$slots.desc)?_c('div',{staticClass:"page-desc"},[_vm._t("desc")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }